<template lang="pug">
  div(v-click-outside="hide")
    .job-show(:class="{ open: isOpened }")
      .job-show-modal#job-show-modal
        a.job-show-modal-close(@click="hide")
          | 閉じる
        .job-show-modal-header
          .new(v-if="jobDetail.is_new")
            span.label NEW
          .employment_name
            span.label(v-for="employment_name in jobDetail.employment_name")
              | {{ employment_name }}
          // JobATagFavoriteStar(:job="jobDetail",
          //                     :updateFavorForIndex="updateFavorForIndex",
          //                     @update="update")
          h4.catchcopy
            | {{ jobDetail.jobtype_name }}
          .company_name
            | {{ jobDetail.company_name }}
        .job-show-modal-body
          .row(v-if="jobDetail.image_url1")
            .img-flex-4
              a(v-if="jobDetail.image_url1"
                target="_blank"
                :href="jobDetail.image_url1")
                img(:src="jobDetail.image_url1")
              a(v-if="jobDetail.image_url2"
                target="_blank"
                :href="jobDetail.image_url2")
                img(:src="jobDetail.image_url2")
              a(v-if="jobDetail.image_url3"
                target="_blank"
                :href="jobDetail.image_url3")
                img(:src="jobDetail.image_url3")
              a(v-if="jobDetail.image_url4"
                target="_blank"
                :href="jobDetail.image_url4")
                img(:src="jobDetail.image_url4")
          .row
            .col.title
              | 求人ID
            .col
              span {{ jobDetail.id }}
          .row(v-if="jobDetail.media_name")
            .col.title
              | 掲載メディア
            .col
              AbbreviationText(:text="jobDetail.media_name")
              a(v-if="jobDetail.job_id && jobDetail.media_url"
                :href="jobDetail.media_url"
                class="external_link"
                target="_blank"
                rel="noopener noreferrer")
                i.fas.fa-external-link-alt
                |  掲載元で確認
          .row(v-if="jobDetail.article_plan_name")
            .col.title
              | 広告プラン
            .col
              AbbreviationText(:text="jobDetail.article_plan_name")
          .row
            .col.title
              | 採用担当者
            .col(v-if="jobDetail.recruiting_personnel")
              AbbreviationText(:text="jobDetail.recruiting_personnel")
            .col(v-else)
              | −
          .row(v-if="jobDetail.view_term")
            .col.title
              | 掲載状況
            .col
              span(v-if="jobDetail.posting") 掲載中(
              span(v-else) 終了(
              span(v-html="jobDetail.view_term")
              | )
          .row(v-if="jobDetail.catchcopy")
            .col.title
              | キャッチコピー
            .col
              AbbreviationText(:text="jobDetail.catchcopy")
          .row(v-if="jobDetail.job_contents")
            .col.title
              | 仕事内容
            .col
              AbbreviationText(:text="jobDetail.job_contents")
          .row(v-if="jobDetail.salary_contents")
            .col.title
              | 給与
            .col
              AbbreviationText(:text="jobDetail.salary_contents")
          .row(v-if="jobDetail.recruits")
            .col.title
              | 採用予定人数
            .col
              AbbreviationText(:text="jobDetail.recruits")
          .row(v-if="jobDetail.work_place")
            .col.title
              | 勤務地
            .col
              AbbreviationText(:text="jobDetail.work_place")
        button.button-more(
          @click="toggleDetail"
          v-if="needsDetail && !detailIsOpened")
          | もっと詳しく見る
        .job-show-modal-more(:class="{ open: detailIsOpened }")
          .row(v-if="jobDetail.pr_point && jobDetail.pr_point.some(p => !!p)")
            .col.title
              | 特徴
            .col
              span.label(v-for="p in jobDetail.pr_point")
                | {{ p }}
          .row(v-if="jobDetail.working_hours")
            .col.title
              | 勤務時間
            .col
              AbbreviationText(:text="jobDetail.working_hours")
          .row(v-if="jobDetail.working_shift")
            .col.title
              | 勤務時間例
            .col
              AbbreviationText(:text="jobDetail.working_shift")
          .row(v-if="jobDetail.background")
            .col.title
              | 募集背景
            .col
              AbbreviationText(:text="jobDetail.background")
          .row(v-if="jobDetail.requestment")
            .col.title
              | 求める人材
            .col
              AbbreviationText(:text="jobDetail.requestment")
          .row(v-if="jobDetail.timeschedule")
            .col.title
              | 1日の仕事の流れ
            .col
              AbbreviationText(:text="jobDetail.timeschedule")
          .row(v-if="jobDetail.attraction")
            .col.title
              | 仕事の魅力
            .col
              AbbreviationText(:text="jobDetail.attraction")
          .row(v-if="jobDetail.appeal_point")
            .col.title
              | アピールポイント
            .col
              AbbreviationText(:text="jobDetail.appeal_point")
          .row(v-if="jobDetail.acquiring_skills")
            .col.title
              | 身につくスキル、磨ける能力
            .col
              AbbreviationText(:text="jobDetail.acquiring_skills")
          .row(v-if="jobDetail.holidays")
            .col.title
              | 休日休暇
            .col
              AbbreviationText(:text="jobDetail.holidays")
          .row(v-if="jobDetail.welfare")
            .col.title
              | 福利厚生・待遇
            .col
              AbbreviationText(:text="jobDetail.welfare")
          .row(v-if="jobDetail.bonus")
            .col.title
              | 昇給・賞与
            .col
              AbbreviationText(:text="jobDetail.bonus")
          .row(v-if="jobDetail.established")
            .col.title
              | 設立年
            .col
              AbbreviationText(:text="jobDetail.established")
          .row(v-if="jobDetail.inteview_place")
            .col.title
              | 面接地（原文）
            .col
              AbbreviationText(:text="jobDetail.inteview_place")
          .row(v-if="jobDetail.qualification")
            .col.title
              | 応募資格
            .col
              AbbreviationText(:text="jobDetail.qualification")
          .row(v-if="jobDetail.application_flow")
            .col.title
              | 応募の流れ
            .col
              AbbreviationText(:text="jobDetail.application_flow")
        template(v-if="jobDetail.in_job_list")
          .sales-status-modal-header
            h4 営業状況
            span 最終更新: {{ jobDetail.job_list.updated_at }}（{{ jobDetail.job_list.updated_by }}）
          .sales-status-modal-body
            form(@submit.prevent="updateJobList")
              .row
                .col.title
                  | 営業ステータス
                .col
                  select(v-model="salesStatus")
                    option(v-for="option in $store.state.master.salesStatuses" :value="option.code") {{ option.name }}
              .row
                .col.title
                  | 営業担当者
                .col
                  select(v-model="assignedTo")
                    option(v-for="option in clientUsers" :value="option.id") {{ option.name }}
              .row
                .col.title
                  | コメント
                .col
                  textarea(v-model="salesStatusComment")
                button.button-more(type="submit" value="コメントを更新する")
                  | 更新する
              ul.timeline
                li(v-for="comment in jobDetail.job_list.comments")
                  .timeline-date
                    | {{ comment.created_at.split(' ')[0] }}
                    p.time
                      i.far.fa-clock
                      |  {{ comment.created_at.split(' ')[1] }}
                  .timeline-comment
                    .timeline-text(v-html="autoLink(comment.comment)")
                    .timeline-author
                      i.fas.fa-user
                      |  {{ comment.author }}
        .company-show-modal-header
           h4 事業所情報
           a(v-if="jobDetail.company_id" @click="openViewHistory") 掲載履歴を確認
        .company-show-modal-body
          .row
            .point(v-if="hasAgentCompany")
              span.label 人材紹介・エージェント
            h4.company_name
              template(v-if="jobDetail.company_id")
                router-link(
                  :to="{name: 'CompanyDetail', query: { id: jobDetail.company_id, from: 'job' }}")
                  span(v-html="jobDetail.company_name")
                .marking(:class="jobDetail.marked ? 'on' : ''")
                  span(v-if="!!jobDetail.company_id" @click="toggleJobMark") マーキング
              template(v-else)
                span(v-html="jobDetail.company_name")
          .row(v-if="jobDetail.campany_place")
            .col.title
              | 所在地
            .col
              span(v-html="jobDetail.campany_place")
          .row(v-if="jobDetail.company_access")
            .col.title
              | アクセス情報
            .col
              span(v-html="jobDetail.company_access")
          .row(v-if="jobDetail.campany_tel")
            .col.title
              | 電話番号
            .col
              span(v-html="jobDetail.campany_tel")
          .row(v-if="jobDetail.campany_guessed_tel")
            .col.title
              | 電話番号／総合
            .col
              span(v-html="jobDetail.campany_guessed_tel")
          .row(v-if="jobDetail.company_url")
            .col.title
              | URL
            .col
              span
                a(:href="jobDetail.company_url" target="_blank" rel="noopener noreferrer")
                  | {{ jobDetail.company_url }}
          .row(v-if="jobDetail.capital")
            .col.title
              | 資本金
            .col
              span(v-html="jobDetail.capital")
          .row(v-if="jobDetail.sales")
            .col.title
              | 売上高
            .col
              span(v-html="jobDetail.sales")
          .row(v-if="jobDetail.employee_amount")
            .col.title
              | 従業員数
            .col
              span(v-html="jobDetail.employee_amount")
          .row(v-if="jobDetail.president_name")
            .col.title
              | 代表者
            .col
              span(v-html="jobDetail.president_name")
          .row(v-if="jobDetail.company_contents")
            .col.title
              | 事業内容
            .col
              span(v-html="jobDetail.company_contents")
          .row(v-if="jobDetail.in_job_mark")
            .col.title
              | コメント
            form(@submit.prevent="updateComment")
              .col
                textarea( v-model="comment")
                br
                | 最終更新者：{{ jobDetail.comment_updater }}
              input.button-more(type="submit" value="コメントを更新する")
        template(v-if="haken")
          .company-show-modal-header
            h4 派遣元求人
          template(v-for="dispatch_agency_job in jobDetail.dispatch_agency_jobs")
            .company-show-modal-body
              .row
                // .point
                //   span.label マッチ度 {{ dispatch_agency_job.match_total }}%
                h4.company_name
                  template(v-if="dispatch_agency_job.company_id")
                    router-link(
                      :to="{name: 'CompanyDetail', query: { id: dispatch_agency_job.company_id, from: 'haken' }}")
                      span(v-html="dispatch_agency_job.company_name")
                  template(v-else)
                    span(v-html="dispatch_agency_job.company_name")
              .row
                .col.title
                  | 求人ID
                .col
                  span {{ dispatch_agency_job.id }}
              .row(v-if="dispatch_agency_job.media_name")
                .col.title
                  | 掲載メディア
                .col
                  AbbreviationText(:text="dispatch_agency_job.media_name")
              .row(v-if="dispatch_agency_job.view_term")
                .col.title
                  | 掲載状況
                .col
                  span(v-if="dispatch_agency_job.posting") 掲載中(
                  span(v-else) 終了(
                  span(v-html="dispatch_agency_job.view_term")
                  | )
              .row(v-if="dispatch_agency_job.catchcopy")
                .col.title
                  | キャッチコピー
                .col
                  AbbreviationText(:text="dispatch_agency_job.catchcopy")
              .row(v-if="dispatch_agency_job.job_contents")
                .col.title
                  | 仕事内容
                .col
                  AbbreviationText(:text="dispatch_agency_job.job_contents")
              .row(v-if="dispatch_agency_job.requestment")
                .col.title
                  | 求める人材
                .col
                  AbbreviationText(:text="dispatch_agency_job.requestment")
    .modal-cover
</template>

<script>
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  import ClickOutside from 'vue-click-outside'
  import AbbreviationText from './AbbreviationText'
  import JobATagFavoriteStar from './JobATagFavoriteStar'
  import { HumanInfoMessages, DefaultSearchJobQuery } from '../../constants'
  import mapGetSet from '../../libs/map-get-set'
  import job from '../../store/modules/job'

  export default {
    components: { AbbreviationText, JobATagFavoriteStar },
    directives: { ClickOutside },
    props: ['job', 'jobDetail', 'isOpened', 'updateFavorForIndex', 'haken'],

    mounted () {
      this.popupItem = this.$el
    },

    computed: {
      ...mapState({
        comment: state => state.job.comment,
        user: state => state.user.detail,
      }),
      ...mapGetters('common', ['spMode']),
      ...mapGetters('client', ['clientUsers']),
      ...mapGetSet({
        _this: this,
        get: ($vm, $s, k) => $s.state.job[k],
        set: ($vm, $s, k, v) => $s.commit(`job/${k}`, v),
        keys: Object.keys(job.state),
      }),
    },

    data () {
      return {
        needsDetail: false,
        detailIsOpened: false,
        hasAgentCompany: false,
        salesStatusComment: '',
        salesStatus: '',
        assignedTo: '',
      }
    },

    watch: {
      jobDetail () {
        this.scrollTop()
        this.detailIsOpened = false
        this.initSalesStatusForm()
        this.needsDetail =
          (this.jobDetail.pr_point && this.jobDetail.pr_point.some(p => !!p)) ||
          this.jobDetail.background ||
          this.jobDetail.catchcopy ||
          this.jobDetail.requestment ||
          this.jobDetail.timeschedule ||
          this.jobDetail.attraction ||
          this.jobDetail.appeal_point ||
          this.jobDetail.acquiring_skills ||
          this.jobDetail.holidays ||
          this.jobDetail.welfare ||
          this.jobDetail.bonus ||
          this.jobDetail.working_shift ||
          this.jobDetail.established ||
          this.jobDetail.recruits ||
          this.jobDetail.working_hours ||
          this.jobDetail.inteview_place ||
          this.jobDetail.qualification

        this.hasAgentCompany = this.jobDetail.pr_point &&
          this.jobDetail.pr_point.some(p => p === '人材紹介・エージェント')
      },
      isOpened () {
        this.detailIsOpened = false
        if (this.isOpened) {
          this.scrollTop()
          this.initSalesStatusForm()
        }
      },
    },

    methods: {
      ...mapMutations('job', ['uncheckAll', 'clearDetail']),
      ...mapActions('jobMark', ['add', 'remove']),
      hide () {
        this.$emit('hide')
      },
      initSalesStatusForm () {
        if (this.jobDetail.in_job_list) {
          this.salesStatus = this.jobDetail.job_list.sales_status_id
          this.assignedTo = this.jobDetail.job_list.assigned_to_id
          this.salesStatusComment = ''
        }
      },
      openViewHistory () {
        // 当該企業の「全期間」「掲載状態を問わない」求人情報を参照
        const query = {
          ...DefaultSearchJobQuery,
          companyId: this.jobDetail.company_id,
          viewEndDate: 0,
          acquisitionDate: 0,
          perPage: String(this.$store.state.user.detail.jobs_per_page),
          page: '1',
          _t: new Date().getTime(),
        }
        const resolvedRoute = this.$router.resolve({ name: 'SearchJob', query })
        window.open(resolvedRoute.href, '_blank')
      },
      autoLink (text) {
        return text.replace(/(https?:\/\/[\x21-\x7e]+)/gi, "<a href='$1' target='_blank'>$1</a>")
      },
      scrollTop () {
        const modal = document.getElementById('job-show-modal')
        if (modal) {
          modal.scrollTop = 0
        }
      },
      toggleDetail () {
        this.detailIsOpened = !this.detailIsOpened
      },
      update () {
        if (!this.updateFavorForIndex) {
          this.$emit('hide')
          this.clearDetail()
        }
        this.$emit('update', { id: this.jobDetail.id })
      },
      async updateComment () {
        this.$store.commit('common/lockGlobal')
        const comment = this.comment
        const companyId = this.jobDetail.company_id
        const updater = this.user.name

        try {
          await this.$store.dispatch('company/comment', { companyId, comment })
          this.$store.commit('job/updater', { updater })
          this.$store.dispatch('common/pushToastInfo', { info: HumanInfoMessages.SAVE_COMPANY_COMMENT })
          this.sent = true
        } catch (e) {
          this.sent = false
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
      async updateJobList () {
        this.$store.commit('common/lockGlobal')
        const id = this.jobDetail.job_list.id
        const salesStatusId = this.salesStatus
        const assignedToId = this.assignedTo
        const comment = this.salesStatusComment
        try {
          this.$store.dispatch('jobList/update', { id, salesStatusId, assignedToId, comment })
          this.salesStatusComment = ''
          this.$store.dispatch('common/pushToastInfo', { info: HumanInfoMessages.SAVE_SALES_STATUS })
        } catch (e) {
          this.$store.dispatch('common/pushToastError', { error: e })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
      async toggleJobMark () {
        if (this.jobDetail.marked) {
          if (this.jobDetail.job_mark_user !== this.user.name) {
            return
          }
        }
        this.$store.commit('common/lockGlobal')
        try {
          this.jobDetail.marked
            ? await this.remove({ id: this.jobDetail.company_id })
            : await this.add({ id: this.jobDetail.company_id })
          this.$store.commit('job/mark', { ids: this.jobDetail.company_id, newMarked: !this.jobDetail.marked, markUser: this.user.name })
          this.$store.commit('common/unlockGlobal')
        } catch (e) {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobShowModal.vue